<template>
    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
                         v-if="currentTask.testtask"
                         @click="play(mainElement.audio)">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{$t('№')}}{{currentTask.pos}}.</span>{{ currentTask.testtask }}
                    </div>

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{
                        test.description }}
                    </div>


                    <div class="col-xl-5 col-12 mb-xl-0 mb-5 mt-5">
                        <div class="row justify-content-xl-start justify-content-center">
                            <div v-for="(element, i) in testelements"
                                 :key="i"
                                 class="d-flex my-4 col-12"
                            >
                                <div class="align-self-center">{{element.part1}}</div>
                                <div v-for="(answer, i) in answers"
                                    :key="i"
                                    class="mx-3 align-self-center"
                                >
                                    <button
                                        v-if="(testmode==1 && (!element.answer || element.answer == answer)) || (testmode==0 && (element.type!=='btn-success' || element.word2==answer))"
                                        :class="['btn', 'btn-large',  'test-question-btn', (element.wrong.indexOf(answer)!=-1 || element.type=='btn-success')?element.type:'secondary']"
                                        class="btn btn-secondary btn-large test-question-btn"
                                        @click="checkAnswer(element, answer)"
                                    >
                                        {{ answer }}
                                    </button>
                                </div>
                                <div class="align-self-center">{{element.part2}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center text-center no-gutters">
                    <button
                            v-if="testmode==1 && done"
                            class="btn btn-info mt-1"
                            @click="next"
                    >
                        {{ $t('accept_answer') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>

</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test11',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },

        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            answers: [],
            done: false,
            complete: false,
            errorCount: 0,

            audio: new Audio(),
            forceRenderKey: 0,

            //errorChord: 'gong.mp3',
            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',

            showTestIntro: true,
        }),

        computed: {
            currentTask: function () {
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                return this.getBy('ismain', 1, this.testelements)
            },

        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },

        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data

                    this.answers = []
                    for (let index = 0; index < this.testelements.length; index++) {
                        this.testelements[index].wrong = []
                        this.testelements[index].part1 = this.testelements[index].word.split(/_+/)[0]
                        this.testelements[index].part2 = this.testelements[index].word.split(/_+/)[1]
                        if (this.answers.indexOf(this.testelements[index].word2) < 0) this.answers.push(this.testelements[index].word2)
                    }

                    this.play(this.mainElement.audio)
                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            // console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            isTaskComplete() {
                this.errorCount = 0
                for (let index = 0; index < this.testelements.length; index++) {
                    if (this.testelements[index].correct !== true) this.errorCount++
                }

                return !this.errorCount
            },

            isTaskDone() {
                for (let index = 0; index < this.testelements.length; index++) {
                    if (!this.testelements[index].answer) return false
                }

                return true
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            next: function () {
                if (this.complete) this.$emit('correctAnswer')
                else this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Ошибок: ${this.errorCount}.`})
                this.taskIdx++
            },

            checkAnswer: async function (element, answer) {
                if(this.testmode == 1) {
                    element.correct = (element.word2 === answer)
                    Vue.set(element, 'answer', answer)
                } else if (element.word2 === answer) {
                    Vue.set(element, 'type', 'btn-success')
                    element.correct = true
                    if (element.audio) {
                        await this.play(element.audio)
                    } else {
                        await this.play(this.okChord)
                    }
                } else {
                    element.correct = false
                    if(element.wrong.indexOf(answer)==-1) Vue.set(element, 'wrong', element.wrong.concat([answer]) )
                    Vue.set(element, 'type', 'secondary') // for watch renderer
                    Vue.set(element, 'type', 'btn-danger')
                    console.log(element.wrong)
                    await this.play(this.errorChord)
                }

                this.complete = this.isTaskComplete()
                this.done = this.isTaskDone()
                if(this.testmode == 0 && this.complete) this.next()

            },
        },
    }
</script>
